<div class="modal-header">
  <h4 class="modal-title"
      [innerHtml]="('ADD_DEVICE'|translate) + ' : ' + projectDeviceLocation.name"></h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close('Close click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>


<div class="filter-for-list">
  <!--{{projectUsers.length}}-->

  <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
    <input matInput [value]="devices ? devices.filter : null" (keyup)="applyFilter($event.target.value)"
           [placeholder]="'SEARCH' | translate">
  </mat-form-field>

  <div class="deviceTypeFilter" placement="right"
       [ngbTooltip]="'DEVICE_TYPE_CHIPS' | translate">
    <app-device-type-selector [projectDeviceLocationMode]="true" [deviceTypeSelected]="deviceTypeSelected"
                              (deviceTypeChanged)="filterListByDeviceType($event)"></app-device-type-selector>
    <span *ngIf="deviceTypeSelected === 0" style="color:red;float:left">Please select a device type</span>

  </div>
  <br clear="both"/>
</div>
<app-progressbar *ngIf="showSpinner"></app-progressbar>
<table mat-table [dataSource]="devices" matSort class="table-striped" style="width:100%">

  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</th>
    <td mat-cell *matCellDef="let device"> {{device.id}}</td>
  </ng-container>

  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'TYPE'|translate}}</th>
    <td mat-cell *matCellDef="let device">
      <mat-chip-list>
        <mat-chip>
          {{device.device_type | translate}}

        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>


  <ng-container matColumnDef="uid">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'UID'|translate}}</th>
    <td mat-cell *matCellDef="let device">


                        <span *ngFor="let parent of device.parents" style="display: inline-block">

                 <mat-chip-list style="display: inline-block">
                        <mat-chip *ngIf="parent.id" matBadgePosition="below after" matBadgeColor="accent"
                                  [matBadge]="parent.channel">{{parent.device_type|translate}}
                        </mat-chip>
                    </mat-chip-list>
                    <span class="linkInList">{{parent.uid}} </span>
   <mat-icon class="arrow-parent">play_arrow
            </mat-icon>

            </span>
      <span style="display: inline-block">

                 <mat-chip-list style="display: inline-block">
                        <mat-chip *ngIf="device.id" matBadgePosition="below after" matBadgeColor="accent"
                                  [matBadge]="device.channel">{{device.device_type|translate}}
                        </mat-chip>
                    </mat-chip-list>
                    <span class="linkInListPrincipal">{{device.uid}} </span>
            </span>


    </td>
  </ng-container>


  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef>{{'ACTIONS'|translate}}</th>
    <td mat-cell *matCellDef="let device">

      <mat-icon style="color:green;cursor:pointer" (click)="patchProjectDeviceLocation(device.id)"
                matTooltipPosition="right"
                [matTooltip]="'CREATE_ICON_TOOLTIP'|translate">check_circle
      </mat-icon>
    </td>
  </ng-container>


  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>

<mat-paginator [pageSizeOptions]="[5,10,20]" showFirstLastButtons [pageSize]="5"></mat-paginator>


<div class="modal-footer">

  <button type="button" class="btn btn-light" (click)="activeModal.close('Close click')"
          [innerHTML]="'CLOSE' | translate">Close
  </button>
</div>
